// extracted by mini-css-extract-plugin
export default {"textarea":"textarea_textarea__K4ffq"};